import { render } from "./HeadCell.vue?vue&type=template&id=e28d8184&scoped=true"
import script from "./HeadCell.vue?vue&type=script&lang=js"
export * from "./HeadCell.vue?vue&type=script&lang=js"

import "./HeadCell.vue?vue&type=style&index=0&id=e28d8184&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28d8184"]])

export default __exports__